import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { Link } from 'react-router-dom'
import {
  AccountCircle,
  LibraryBooks,
  Science,
  EmojiEvents,
  FactCheck,
  AttachFile,
  Subscriptions,
  MilitaryTech,
  WorkspacePremium,
} from '@mui/icons-material'
import { useAuth } from 'contexts/AuthContext' // <-- NEW: Import useAuth

const drawerWidth = 240

export default function PageAppBar({
  pageName,
  children,
}: {
  pageName: String
  children?: React.ReactNode
}) {
  const { logout } = useAuth() // <-- NEW: Use the logout function from context

  // --- UPDATED: handleLogout now uses context ---
  const handleLogout = () => {
    logout()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        maxWidth: '100vw',
      }}
    >
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {pageName}
          </Typography>
          <Button color="inherit" onClick={handleLogout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        anchor="left"
      >
        <Toolbar />
        <List>
          {/* Comptes */}
          <Link
            to="/users"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <AccountCircle />
                </ListItemIcon>
                <ListItemText primary="Comptes" />
              </ListItemButton>
            </ListItem>
          </Link>
          {/* Profils */}
          <Link
            to="/profiles"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <EmojiEvents />
                </ListItemIcon>
                <ListItemText primary="Profils" />
              </ListItemButton>
            </ListItem>
          </Link>
          {/* Licences */}
          <Link
            to="/licenses"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <FactCheck />
                </ListItemIcon>
                <ListItemText primary="Licences" />
              </ListItemButton>
            </ListItem>
          </Link>
          {/* Activités */}
          <Link
            to="/activities"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <LibraryBooks />
                </ListItemIcon>
                <ListItemText primary="Activités" />
              </ListItemButton>
            </ListItem>
          </Link>
          {/* Jalons (Milestones) */}
          <Link
            to="/milestones"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <MilitaryTech />
                </ListItemIcon>
                <ListItemText primary="Jalons" />
              </ListItemButton>
            </ListItem>
          </Link>
          {/* --- NEW: Badges Link --- */}
          <Link
            to="/badges"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <WorkspacePremium />
                </ListItemIcon>
                <ListItemText primary="Badges" />
              </ListItemButton>
            </ListItem>
          </Link>
          {/* Tests */}
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Science />
              </ListItemIcon>
              <ListItemText primary="Tests" />
            </ListItemButton>
          </ListItem>
          {/* Ressources */}
          <Link
            to="/resources"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <AttachFile />
                </ListItemIcon>
                <ListItemText primary="Ressources" />
              </ListItemButton>
            </ListItem>
          </Link>
        </List>
        <Divider />
        <List>
          {/* Abonnements */}
          <Link
            to="/subscriptions"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <Subscriptions />
                </ListItemIcon>
                <ListItemText primary="Abonnements" />
              </ListItemButton>
            </ListItem>
          </Link>
        </List>
      </Drawer>
      <Box
        sx={{
          flex: 1,
          overflow: 'scroll',
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  )
}
